// assets/faq-accordion-accessibility.js

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Selektiere alle FAQ-Accordion-Listen
    const accordions = document.querySelectorAll('.faqAccordion');

    accordions.forEach((accordion) => {
      const buttons = Array.from(accordion.querySelectorAll('dt > button'));

      buttons.forEach((btn, idx) => {
        // Klick-Handler: toggelt expanded/hidden
        btn.addEventListener('click', function() {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          panel.setAttribute('aria-hidden', String(expanded));
        });

        // Keyboard-Handler: Pfeilnavigation + Enter/Space zum Toggeln + Home/End
        btn.addEventListener('keydown', function(event) {
          let newIdx;
          switch (event.key) {
            case 'ArrowUp':
            case 'ArrowLeft':
              newIdx = (idx - 1 + buttons.length) % buttons.length;
              buttons[newIdx].focus();
              event.preventDefault();
              break;

            case 'ArrowDown':
            case 'ArrowRight':
              newIdx = (idx + 1) % buttons.length;
              buttons[newIdx].focus();
              event.preventDefault();
              break;

            case 'Home':
              buttons[0].focus();
              event.preventDefault();
              break;

            case 'End':
              buttons[buttons.length - 1].focus();
              event.preventDefault();
              break;

            case 'Enter':
            case ' ':
              btn.click();
              event.preventDefault();
              break;
          }
        });
      });
    });
  });
})();
